import { render, staticRenderFns } from "./TransactionChargeBack.vue?vue&type=template&id=3bf2ff63&"
import script from "./TransactionChargeBack.vue?vue&type=script&lang=ts&"
export * from "./TransactionChargeBack.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports